// extracted by css-extract-rspack-plugin
module.exports =  {"floatingButtonSpace":"FloatingButton__floatingButtonSpace--WXMQ5"};